import { render, staticRenderFns } from "./PortalManagement.vue?vue&type=template&id=153957e4&"
import script from "./PortalManagement.vue?vue&type=script&lang=js&"
export * from "./PortalManagement.vue?vue&type=script&lang=js&"
import style0 from "./PortalManagement.vue?vue&type=style&index=0&id=153957e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports